import { Observable } from "rxjs";

export abstract class BaseDTO<T, R>{
    abstract mapTo(data: T): R | Observable<R>
} 